import { CAREERS_URL, PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '~/lib/urls';

export const companyLinks = {
  title: 'Company',
  items: [
    {
      text: 'Careers',
      href: CAREERS_URL,
    },
    {
      text: 'Privacy',
      href: PRIVACY_POLICY_URL,
    },
    {
      text: 'Terms',
      href: TERMS_OF_SERVICE_URL,
    },
  ],
};
